<template>
  <dialog-modal-fi
    ref="modal"
    class="seminar-info-dialog-fi"
    lazy
  >
    <template #header>
      <h2
        v-if="fields.infoDialogHeadline?.value"
        class="seminar-info-dialog-fi__headline"
      >
        {{ fields.infoDialogHeadline.value }}
      </h2>
    </template>
    <template #body>
      <div
        v-if="fields.infoDialogText?.value"
        class="seminar-info-dialog-fi__text"
      >
        <richtext-fi :html-content="fields.infoDialogText" />
      </div>
    </template>
  </dialog-modal-fi>
</template>

<script setup lang="ts">
import { DialogModalFi, RichtextFi } from 'atoms';
import { useTemplateRef } from 'vue';

import { useFields } from '@/composables/fields';

defineOptions({ name: 'SeminarInfoDialogFi' });

const fields = useFields('SeminarsOverviewFiFields');

const modal = useTemplateRef<{ open: () => void }>('modal');

function open() {
  modal.value?.open();
}

defineExpose({ open });
</script>

<style scoped src="./seminar-info-dialog-fi" />
